import axios from "axios";
import lytSoftLogo from "@/assets/img/use.png";
import lytSILogo from "@/assets/img/si-logo.png";
import {Storage} from "@/Services/Storage";
export default {
  name: 'smart-invoice',
  state: {
    productList : [
      {
        id : `1`,
        name : "Lyt-Soft POS",
        imageSrc : lytSoftLogo,
        route : {
          name : "lytsoft-smart-invoice"
        }
      },
      {
        id : `2`,
        name : "Chrilan Smart Invoice (Lyt-SI)",
        imageSrc : lytSILogo,
        route : {
          name : "chrilan-smart-invoice"
        }
      },
    ]
  },
  getters: {
    getSmartInvoiceProductList:(state) =>state.productList,
  },
  mutations: {},
  actions: {
    /**
     * Approve a single branch for LytSoft Smart Invoice onboarding.
     * Uses the per-branch endpoint documented in TicketApp API.
     *
     * @param {Object} context - Vuex action context
     * @param {Object} payload
     * @param {number|string} payload.ticketID - Ticket ID
     * @param {Object} payload.branch - { store_database, branchCode, deviceSerialNumber }
     * @returns {Promise<{ticketClosed:boolean, message:string}>}
     */
    markLytSoftBranchAsApproved: async (context, { ticketID, branch }) => {
      const userObj = JSON.parse(localStorage.getItem('current_store')) || {};
      const user = userObj?.Username || 'unknown';
      const url = ticketApi + `smartInvoiceOnboard/markBranchAsApproved`;
      const body = { ticketID, user, branch };
      return axios.post(url, body)
        .then(({ data }) => data)
        .catch(err => errorHandler.tomcatError(err, true));
    },
    searchSignUps: (context, payload) => {
      const to = context.getters.getGlobalDateRange.To;
      const from = context.getters.getGlobalDateRange.From;
      payload = {
        ...payload,
        to,
        from
      }
      return axios.get(lytSIApi+`smart-invoice-signup/signups/search`,{
        params : payload
      }).then(({data})=>data.response).catch(err=>errorHandler.tomcatError(err))
    },
    searchLytSoftSignUps: (context, payload) => {
      const to = context.getters.getGlobalDateRange.To;
      const from = context.getters.getGlobalDateRange.From;
      payload = {
        ...payload,
        to,
        from
      }
      return axios.get(ticketApi+`smartInvoiceOnboard/search`,{
        params : payload
      }).then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
    },
    searchKazangSignUps: (context, payload) => {
      const to = context.getters.getGlobalDateRange.To;
      const from = context.getters.getGlobalDateRange.From;
      payload = {
        ...payload,
        to,
        from
      }
      return axios.get(ticketApi+`smartInvoiceOnboard/kazang/search`,{
        params : payload
      }).then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
    },
    getChrilanSignUpByID: (context, id) => {
      return axios.get(lytSIApi+`smart-invoice-signup/signup/${id}`,)
          .then(({data})=>data.response).catch(err=>errorHandler.tomcatError(err))
    },
    getChrilanDocByID: (context, id) => {
      return window.open(lytSIApi+`smart-invoice-signup/commitmentform/download-pdf/${id}`);
    },
    getLytSoftSignUpByID: (context, id) => {
      return axios.get(ticketApi+`smartInvoiceOnboard/getByID/${id}`,)
          .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
    },
    getLytSoftLogsBySignUp: (context, id) => {
      return axios.get(ticketApi+`smartInvoiceOnboard/getSubmissionLogs/${id}`,)
          .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
    },
    getSILogsBySignUp: (context, id) => {
      return axios.get(lytSIApi+`smart-invoice-signup/signup-logs/${id}`,)
          .then(({data})=>data.response).catch(err=>errorHandler.tomcatError(err))
    },
    getLytSoftBranchesBySignUp: (context, id) => {
      return axios.get(ticketApi+`smartInvoiceOnboard/getStoresSubmitted/${id}`,)
          .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
    },
    getSIBranchesBySignUp: (context, id) => {
      return axios.get(lytSIApi+`smart-invoice-signup/signup-branches/${id}`,)
          .then(({data})=>data.response).catch(err=>errorHandler.tomcatError(err))
    },
    // GINGER-2026-09-02: ticket #27815 — operator UI to set missing customer/store
    checkMissingCustomerStore: (context, ticketId) => {
        return axios.get(ticketApi+`smartInvoiceOnboard/missing-customer-store/${ticketId}`)
            .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
    },
    setMissingCustomerStore: async (context, payload) => {
        let user = JSON.parse(localStorage.getItem('current_store'));
        payload.user = user.Username;
        return axios.post(ticketApi+`smartInvoiceOnboard/set-customer-store/${payload.ticketId}`, payload)
            .catch(err=>errorHandler.tomcatError(err,true))
        },
        // GINGER-2026-09-02: ticket #27815 — autocomplete source for the Client picker
        searchCustomers: (context, query) => {
            const q = (query || '').trim();
            return axios.get(ticketApi+`reg/Customer/searchCustomers`, {
                params: { customerName: q, limit: 20 }
            }).then(({data})=>{
                const rows = Array.isArray(data) ? data : (data && Array.isArray(data.response) ? data.response : []);
                return rows.map(r => ({
                    id: r.id ?? r.ID ?? r.Id,
                    Name: r.Name ?? r.name,
                    tpin: r.tpin ?? r.TPIN,
                    CellNumber: r.CellNumber ?? r.cellNumber,
                }));
            }).catch(err=>errorHandler.tomcatError(err))
        },
    markLytSoftSubmissionAsDone: async (context, payload) => {
        let user = JSON.parse(localStorage.getItem('current_store'));
        payload.user = user.Username;
        return axios.post(ticketApi+`smartInvoiceOnboard/markAsSubmitted`,payload)
            .catch(err=>errorHandler.tomcatError(err,true))
    },
    markSISubmissionAsDone: async (context, payload) => {
      let user = JSON.parse(localStorage.getItem('current_store'));
      payload.user = user.Username;
      let url =  lytSIApi+`smart-invoice-signup/mark-as-submitted`;
      return context.dispatch(`sendRequest`,{url , payload});
    },
    markSIApprovedAsDone: async (context, payload) => {
      let user = JSON.parse(localStorage.getItem('current_store'));
      payload.processedBy = user.Username;
      let url =  lytSIApi+`smart-invoice-signup/signup-status/update`;
      return context.dispatch(`sendRequest`,{url , payload});
    },
    markSIDeclinedAsDone: async (context, payload) => {
      let user = JSON.parse(localStorage.getItem('current_store'));
      payload.processedBy = user.Username;
      let url =  lytSIApi+`smart-invoice-signup/signup-status/update`;
      return context.dispatch(`sendRequest`,{url , payload});
    },
    markLytSoftApprovalAsDone: async (context, payload) => {
      let user = JSON.parse(localStorage.getItem('current_store'));
      payload.user = user.Username;
      return axios.post(ticketApi+`smartInvoiceOnboard/markAsApproved`,payload)
          .catch(err=>errorHandler.tomcatError(err,true))
    },
    getSignUpStatuses: () => {
      return axios.get(lytSIApi+`smart-invoice-signup/signup-statuses`)
          .then(({data})=> data.response)
          .catch(err=>errorHandler.tomcatError(err))
    },
    searchZraCategories:async (context , payload) =>{
      return axios.get(franchiseTomcatApi+`category/maindb/searchZRACatgeories?name=`+payload)
          .then(({data})=>data)
    },

    createSINote:(context , payload)=>{
      let url = lytSIApi+`smart-invoice-signup/notes`;
      return context.dispatch(`sendRequest`,{url , payload});
    },
    getSignNotes: (context, signup) => {
      return axios.get(lytSIApi+`smart-invoice-signup/notes-by-signup-id/${signup}`)
          .then(({data})=> data.response)
          .catch(err=>errorHandler.tomcatError(err))
    },
    /**
     * Roll a stuck CONFIRM_RESOLVED ticket back to IN_PROGRESS via the test-helper
     * endpoint. Mirrors POST /smartInvoiceOnboard/revertToSubmitted/{id}. The endpoint
     * branches on current status: CONFIRM_RESOLVED → REJECT_CONFIRM, CLOSED → REOPEN.
     * @param context
     * @param {{ticketID:number}} payload
     * @returns {Promise<{success:boolean, message:string, command?:string, fromStatus?:string}>}
     */
    revertLytSoftToSubmitted: async (context, payload) => {
      return axios.post(`${ticketApi}smartInvoiceOnboard/revertToSubmitted/${payload.ticketID}`)
        .then(({ data }) => data)
        .catch(err => Promise.reject(err));
    },
    /**
     * Combined retry path for tickets stuck in CONFIRM_RESOLVED. Reverts to IN_PROGRESS
     * then loops through the supplied branches calling markLytSoftBranchAsApproved per
     * branch. Kazang's markSelectedLytSoftBranchesApproved wrapper from the Synergy
     * Help-Desk isn't present in this store, so the per-branch loop lives inline here.
     * @param context
     * @param {{ticketID:number, branches:Array<{store_database:string, branchCode:string, deviceSerialNumber:string}>}} payload
     * @returns {Promise<{success:number, failed:number, total:number, results:Array, failures:Array}>}
     */
    revertAndRetryLytSoftApprove: async (context, payload) => {
      await context.dispatch('revertLytSoftToSubmitted', { ticketID: payload.ticketID });
      const results = [];
      const failures = [];
      for (const branch of (payload.branches || [])) {
        if (!branch || !branch.store_database || !branch.branchCode || !branch.deviceSerialNumber) {
          const entry = { ...branch, success: false, message: 'Missing required branch data' };
          results.push(entry); failures.push(entry);
          continue;
        }
        try {
          const res = await context.dispatch('markLytSoftBranchAsApproved', {
            ticketID: payload.ticketID,
            branch,
          });
          results.push({ ...branch, success: true, message: res?.message || 'Approved.' });
        } catch (e) {
          const msg = (e?.response?.data?.message) || e?.toString?.() || String(e);
          results.push({ ...branch, success: false, message: msg });
          failures.push({ ...branch, success: false, message: msg });
        }
      }
      const success = results.filter(r => r.success).length;
      const failed = results.length - success;
      return { results, counts: { success, failed, total: results.length }, failures };
    },
  }
}
